export const YES_NO = "yes";
export const ALERT = "alert";
